import { render, staticRenderFns } from "./FinishedProjectsView.vue?vue&type=template&id=b1aab39e&scoped=true"
import script from "./FinishedProjectsView.vue?vue&type=script&lang=js"
export * from "./FinishedProjectsView.vue?vue&type=script&lang=js"
import style0 from "./FinishedProjectsView.vue?vue&type=style&index=0&id=b1aab39e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1aab39e",
  null
  
)

export default component.exports